import { createCustomEvent } from "../../shared/helpers";

export default class extends Controller {
  connect() {
    App.Helpers.addAjaxSuccessHandler(this.element, this.emitMeetingCreateEvent.bind(this));
  }

  emitMeetingCreateEvent(event, data) {
    const { milestone_id: milestoneID } = data;
    document.dispatchEvent(createCustomEvent("milestone:meeting-create:success", this.element, { milestoneID }));
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/meetings/meetings-milestone-meetings-new-controller.js